<div class="user-search-form position-relative">
  <div class="form-holder">
    <input type="text" class="form-control" placeholder="Search users" [formControl]="searchControl">
    <span class="icon-search position-absolute"></span>
  </div>
  <a class="delete" (click)="onClearAll()"><span class="far fa-trash-alt"></span></a>
</div>

<div class="user-filter-list">
  <span class="user-title">Select users</span>

  <div class="user-list-holder">
    <div class="user-list" *ngFor="let user of rows" (click)="onClickUser(user); $event.stopPropagation();">
      <div class="input-check">
        <input class="form-check-input" type="checkbox" [ngModel]="user.selected" [disabled]="limit > 0 && !user.selected && selectCount >= limit" />
      </div>
      <span class="user-short">{{user.fullName | initials}}</span>
      <div class="name-email">
        <span class="name">{{user.username}}</span>
        <span class="email">{{user.email}}</span>
      </div>
    </div>
  </div>

</div>
